module.exports = __webpack_public_path__ + "images/logo-9a7d6dc141bf04315c66d381f9f14590.svg";